import React from "react";
import { observer } from "mobx-react-lite";
import { formatDateTime } from "../../../utils/localizations";
import ListView from "../../common/list";
import type { ColumnDefinition } from "@frui.ts/dataviews";
import type { Action } from "../../../entities/bankExport";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import BankExportDetailListViewModel from "../../../viewModels/finance/bankExports/bankExportDetailListViewModel";

const bankExportDetailListView: ViewComponent<BankExportDetailListViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<Action>[] = [
    {
      title: vm.translateAttribute("actionAt"),
      valueFormatter: props => formatDateTime(props.value),
      property: "actionAt",
      cellProps: props => ({
        style: {
          width: 200,
        },
      }),
    },
    {
      title: vm.translateAttribute("actionBy"),
      property: "actionBy",
    },
    {
      title: vm.translateAttribute("description"),
      property: "description",
    },
  ];
  return <ListView vm={vm} columns={columns} hideTitle={true} />;
});

registerView(bankExportDetailListView, BankExportDetailListViewModel);
